import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetClassroomTypesQuery } from "../../hooks/useGetClassroomTypesQuery";
import { setClassroomData } from "../../redux/slices/school/classroom";
import { routes } from "../../routes";
import { updateClassRoom } from "../../services/school/classroom/classroom";
import { ClassroomType } from "../../types/Classroom";
import { Key_classroom } from "../../utils/constants";
import { useGetClassroomQuery } from "../../hooks/useGetClassroomQuery";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";

const columnNamesMap: { [key: string]: string } = {
    description: 'Nome',
    classroomType: 'Tipo de sala',
    departament: 'Departamento',
};
export const Classrooms = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetClassroomQuery({ PageNumber: currentPage, PageSize: 400 });
    const [deleteItem, setDeleteItem] = useState<ClassroomType | null>(null);
    const mutationUpdate = useMutation(updateClassRoom, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_classroom);
            toast.success('Sala apagada');
        },
        onError: () => {
            toast.error("Erro ao apagar sala.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createClassroom)
    }
    const handleEdit = (classroom: ClassroomType) => {
        dispatch(setClassroomData(classroom));
        navigate(routes.updateClassroom)
    };
    const handleDelete = (classroom: ClassroomType) => {
        classroom.status = false;
        mutationUpdate.mutateAsync(classroom)
    };
    const openDeleteDialog = (s: ClassroomType) => {
        setDeleteItem(s);
    };  
    const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem!)
        }
    };
    
    const options = data?.items.map((classroom: ClassroomType) => [
        {
            label: 'Editar',
            onClick: () => handleEdit(classroom),
            icon: <Pencil1Icon />
        },
        {
            label: 'Eliminar',
            onClick: () => openDeleteDialog(classroom),
            icon: <TrashIcon />
        }
    ]) || [];
    
    return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
    );
}

